enum Section {
  Videos,
  RecordedWebinars,
  UpcomingWebinars,
}
export default Section
